// src/hooks/useUsuariosKanban.ts
import { useCallback } from 'react';
import { apiGet } from '../services/api';
import { Pessoa, PessoaIntegration } from '../types/usuarios/Pessoa';
import { usePaginatedFetch } from './usePaginatedFetch';

export const useUsuariosKanban = () => {
  const fetchIntegration = useCallback(async (page: number) => {
    const res = await apiGet(`/v1/pessoas-connection?semUsuario=true&page=${page}&size=10`);
    return { items: res.data.content as PessoaIntegration[], totalItems: res.data.page.totalElements };
  }, []);

  const fetchActive = useCallback(async (page: number) => {
    const res = await apiGet(`/v1/pessoas?ativo=true&page=${page}&size=10`);
    return { items: res.data.content as Pessoa[], totalItems: res.data.page.totalElements };
  }, []);

  const fetchInactive = useCallback(async (page: number) => {
    const res = await apiGet(`/v1/pessoas?ativo=false&page=${page}&size=10`);
    return { items: res.data.content as Pessoa[], totalItems: res.data.page.totalElements };
  }, []);

  const integration = usePaginatedFetch<PessoaIntegration>({
    fetchFunction: fetchIntegration,
    pageSize: 10,
    initialPage: 0,
  });

  const active = usePaginatedFetch<Pessoa>({
    fetchFunction: fetchActive,
    pageSize: 10,
    initialPage: 0,
  });

  const inactive = usePaginatedFetch<Pessoa>({
    fetchFunction: fetchInactive,
    pageSize: 10,
    initialPage: 0,
  });

  const reloadAllColumns = () => {
    integration.reset();
    active.reset();
    inactive.reset();
  };

  const applySearchResults = (result: {
    ativos: Pessoa[];
    inativos: Pessoa[];
    integracao: PessoaIntegration[];
  }) => {
    active.updateItems(() => result.ativos);
    active.setTotalItems(result.ativos.length);
    inactive.updateItems(() => result.inativos);
    inactive.setTotalItems(result.inativos.length);
    integration.updateItems(() => result.integracao);
    integration.setTotalItems(result.integracao.length);
  };

  return {
    integration,
    active,
    inactive,
    reloadAllColumns,
    applySearchResults,
  };
};
